import { render, staticRenderFns } from "./ModalEditarColaboracao.vue?vue&type=template&id=668ed13d&scoped=true"
import script from "./ModalEditarColaboracao.vue?vue&type=script&lang=js"
export * from "./ModalEditarColaboracao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarColaboracao.vue?vue&type=style&index=0&id=668ed13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ed13d",
  null
  
)

export default component.exports